/**
 * Utils to get access to Environment Variables
 */
export default class EnvironmentUtils {
  public static getVar(key: string): string {
    if (!key) {
      return '';
    }

    return (process.env || {})[key];
  }
}
